import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { countUnique, countUniqueTime } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDateRange, styleTime } from '@utils/styles';
import { REPORT } from '@consts/reports';

interface LocationsNoCutsByMaterialProps {
    dateRange: { startDate: string; endDate: string };
    productName: string;
}

export const LocationsNoCutsByMaterial = ({ dateRange, productName }: LocationsNoCutsByMaterialProps) => {

    const [range, setRange] = useRange('LocationsNoCutsByMaterial');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_LOCATIONS_HAVE_NOT_CUT,
        params: { range, productName, ...dateRange },
    });

    return (
        <BaseReport
            title={`Locations who have not cut ${productName}`}
            description={`This is a list of locations which did not make a cut for ${productName} film in the entire date range above. This may be an indication that the location does not carry ${productName}, or has run out of ${productName} sheets.`}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            setRange={setRange}
            range={range}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', `Last Successful ${productName} Cut`],
                data: data.map((item) => [item.locationName, item.resellerName, item.lastSuccessfulCut || 'never']),
                style: [null, null, styleTime],
                summaries: [countUnique, countUnique, countUniqueTime],
                sort: [basicSort, basicSort, dateSort(range)],
            }}
        />
    );
};
